import { render } from "./cell_click1.vue?vue&type=template&id=476b8fa4"
import script from "./cell_click1.vue?vue&type=script&lang=ts"
export * from "./cell_click1.vue?vue&type=script&lang=ts"
script.render = render

export default script